import React, { useEffect } from 'react';

const APP_SCHEME_URL = 'colquest://';
const IOS_STORE_URL = 'https://apps.apple.com';
const ANDROID_STORE_URL = 'https://play.google.com/store';
const WEB_FALLBACK_URL = 'https://colquest.cc/';

const OpenAppPage: React.FC = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || '';
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);

    // Attempt to open the native app first.
    window.location.href = APP_SCHEME_URL;

    const fallbackUrl = isIOS ? IOS_STORE_URL : isAndroid ? ANDROID_STORE_URL : WEB_FALLBACK_URL;

    // If the app doesn't open, redirect to a platform-specific fallback.
    const timeout = window.setTimeout(() => {
      window.location.href = fallbackUrl;
    }, 1200);

    return () => window.clearTimeout(timeout);
  }, []);

  return (
    <main
      style={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <p style={{ margin: 0 }}>Ouverture de ColQuest...</p>
    </main>
  );
};

export default OpenAppPage;
